(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('HistoricoTarefasCtrl', HistoricoTarefasCtrl);

  HistoricoTarefasCtrl.$inject = [
    '$scope',
    'LoadingService',
    'MessagesService',
    'PeriodSelectService',
    '$route',
    '$routeParams',
    'TarefasService',
    'DeleteDataService',
    'TarefaObjectService',
    '$q',
    '$templateCache',
    'LeafletService',
    'OperacoesDadosService',
    'InfoWindowService',
    'HistoricosService'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function HistoricoTarefasCtrl($scope, LoadingService, MessagesService,
    PeriodSelectService, $route, $routeParams,
    TarefasService, DeleteDataService, TarefaObjectService, $q,
    $templateCache, LeafletService, OperacoesDadosService,
    InfoWindowService, HistoricosService) {
    const vm = this;
    const map = LeafletService.getMap('propriedade-map');
    let hasPage = true;
    let inProgress = false;

    //////////////////////////////////////////
    // Controller data
    vm.tasks = [];
    vm.filters = {
      gleba: null,
      page: 1,
      dataInicial: null,
      dataFinal: null,
      responsavel: null,
      status: null,
      tipo: null
    };
    vm.status = TAREFA_STATUS;
    vm.tipos = TAREFA_TIPOS;
    vm.filtroPeriodo = null;
    vm.period = {
      eventDates: [],
      periodo: ''
    };
    vm.selected = [];
    vm.allSelected = false;

    //////////////////////////////////////////
    // Bindable methods
    vm.showEditTask = showEditTask;
    vm.loadTarefas = loadTarefas;
    vm.showMarkers = showMarkers;
    vm.setFilter = setFilter;
    vm.setPeriodo = setPeriodo;
    vm.openPeriodsFilter = openPeriodsFilter;
    vm.finishTask = finishTask;
    vm.toggle = toggle;
    vm.toggleAll = toggleAll;
    vm.deleteSelected = deleteSelected;

    //////////////////////////////////////////
    // Function declarations

    function showEditTask(data) {
      resetMap();
      $scope.$emit('activateSidebar', 'addTask', { task: data });
    }

    function eventStop(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
    }

    function loadTarefas() {
      if ($scope.$root.permissions.tarefa.canRead) {
        if (vm.filters && vm.filters.page && hasPage && !inProgress) {
          LoadingService.showLoading();
          inProgress = true;

          TarefasService.list(vm.filters).then((data) => {
            /** @type Array */
            const dados = data.data || [];
            hasPage = (((data.pages || {}).pagination || {}).next || 0) > vm.filters.page;

            if (dados.length > 0) {
              vm.filters.page++;
              dados.forEach((task) => {
                task.status = TarefasService.getTaskStatusDescription(task);
                task.status = TarefasService.getTarefaStatus(task.status);
                task.tipo = TarefaObjectService.getTarefaTipo(task.tipo);
                task.tempoDecorrido = moment().diff(task.updated_at, 'days');
                task.nomes_encarregados = task.encarregados.map((encarregado) => encarregado.nome_completo).join(', ');
                task.nomes_pragas = _.map((task.tipo_ocorrencias || []), 'descricao').join(', ');
                task.pragas = (task.tipo_ocorrencias || []);
              });
              vm.tasks = vm.tasks.concat(dados);
            }
          })
            .catch(errorLoadTarefas)
            .finally(() => {
              inProgress = false;
              LoadingService.hideLoading();
            });
        }
      }
    }

    function errorLoadTarefas(error) {
      MessagesService.alert('Não foi possível buscar a lista de Tarefas.');
      inProgress = false;
      LoadingService.hideLoading();
      console.error(error);
    }

    function showMarkers($event, task) {
      if ($event && !task.open) {
        eventStop($event);
      }
      resetMap();
      task.hasMarkers = !task.hasMarkers;

      if (task.hasMarkers) {
        task.loading = true;
        TarefasService.get(task.id).then((tarefa) => {
          task.imagens = tarefa.imagensOrigem.concat(tarefa.imagens);
          task.glebas = tarefa.glebas.map((gleba) => gleba.gleba);
          task.observacao = tarefa.observacao;
          task.area = tarefa.area;
          taskMarkers(tarefa).then((markers) => {
            task.markers = markers.markers;
            addToMap(task.markers);
          })
            .catch((error) => console.error('erro ao exibir markers', error));
        })
          .catch((error) => {
            MessagesService.alert('Falha ao recuperar dados da tarefa, tente novamente.');
            console.error(error);
          })
          .finally(() => {
            task.loading = false;
            task.open = !task.open;
          });
      }
    }

    function toggle($event, task) {
      eventStop($event);
      if (!['pendente', 'atrasado'].includes(task.status.descricao)) {
        return;
      }
      if (vm.selected.includes(task.id)) {
        vm.selected.splice(vm.selected.indexOf(task.id), 1);
      } else {
        vm.selected.push(task.id);
      }
    }

    function toggleAll() {
      vm.allSelected = !vm.allSelected;

      if (vm.allSelected) {
        vm.tasks
          .filter(({ status }) => ['pendente', 'atrasado'].includes(status.descricao))
          .forEach((task) => {
            if (!vm.selected.includes(task.id)) {
              vm.selected.push(task.id);
            }
          });
      } else {
        vm.selected = [];
      }
    }

    function deleteSelected() {
      return MessagesService.confirm('Você tem certeza que deseja apagar os registros selecionados?')
        .then(() => {
          LoadingService.showLoading();
          DeleteDataService.many(vm.selected, ['tarefa'])
            .then(() => {
              MessagesService.alert('Registros apagados!');
              $route.reload();
            })
            .catch((error) => {
              if (error) {
                MessagesService.alert('Não foi possível apagar os registros.');
                console.error('Erro:', error);
              }
              LoadingService.hideLoading();
            })
            .finally(LoadingService.hideLoading);
        });
    }

    function addToMap(markers) {
      markers.forEach((marker) => {
        marker.addTo(map);
        if (marker.circle) {
          marker.circle.addTo(map);
        }
      });
    }

    // TODO: rever
    // eslint-disable-next-line max-lines-per-function
    function taskMarkers(task) {
      // eslint-disable-next-line max-lines-per-function
      return $q((resolve) => {
        const markers = [];
        const template = $templateCache.get('views/infowindow_templates/infowindowoperations.tpl.html');
        const object = task;

        const colorName = (object.tipo.descricao === 'geral' && object.status === 'finalizado') ?
          'realizado' : 'previsto';
        const circleColor = CIRCLE_COLOR[colorName];
        const iconUrl = ICON_MARKER_TAREFA[colorName];

        // eslint-disable-next-line max-lines-per-function
        object.pontos.forEach((tarefa) => {
          const objeto = {};
          objeto.id = tarefa.id;
          objeto.idKey = tarefa.idKey;
          objeto.created_at = object.createdAt;
          objeto.position = {
            lat: parseFloat(tarefa.latitude),
            lng: parseFloat(tarefa.longitude)
          };
          objeto.options = {
            icon: iconUrl
          };
          const marker = LeafletService.createMarker([objeto.position.lat, objeto.position.lng], objeto.options.icon);
          objeto.comentario = marker.comentario = tarefa.comentario;
          marker.id = objeto.id;

          marker.circle = LeafletService.createCircle({
            coordinates: [objeto.position.lat, objeto.position.lng],
            options: {
              radius: RADIUS_TASK_CIRCLE,
              color: circleColor,
              opacity: 0.4
            }
          });

          const infoWindowOject = {
            title: 'Comentário',
            created_at: object.createdAt,
            latitude: tarefa.latitude,
            longitude: tarefa.longitude,
            user: {
              user_name: object.usuario.nome
            },
            accuracy: 'MANUAL',
            template: 'ponto_comentario.html'
          };
          const infoWindow = InfoWindowService.createInfoWindow(template, null, infoWindowOject, marker);

          markers.push({
            leafletMarker: marker,
            infoWindow
          });
        });

        let realized = object.pontosRealizados.map(function(tarefa) {
          return {
            objeto: tarefa.objeto,
            tipo: task.tipo.tipo,
            sincObjectId: tarefa.id,
            created_at: tarefa.created_at,
            imagens: tarefa.imagens,
            audio: { audio: tarefa.audio },
            situacao: tarefa.situacao,
            densidade_ideal: tarefa.densidade_ideal,
            produtividade_alvo: tarefa.produtividade_alvo,
            icon: ICON_MARKER_TAREFA.realizado
          };
        });

        realized = OperacoesDadosService.newGetMarkersOperationsDayGleba(realized, null, template);
        realized.forEach((marker) => {
          markers.push(marker);
        });

        task.markers = markers.map((marker) => marker.leafletMarker);
        resolve(task);
      });
    }

    function setFilter(type, data, $event) {
      eventStop($event);
      vm.filters[type] = data;
      resetMap();
      resetVariables();
      if (type === 'gleba') {
        $route.updateParams({
          gleba: (vm.filters.gleba || {}).id
        });
      }

      const { historyDate } = $routeParams;
      if (historyDate) {
        const periodo = {
          dataInicial: historyDate,
          dataFinal: historyDate,
          descricao: historyDate
        };

        setPeriodo(periodo);
      }
      loadTarefas();
    }

    function setPeriodo(periodo, $event) {
      eventStop($event);
      resetMap();
      resetVariables();
      if (periodo) {
        vm.filters.dataInicial = periodo.dataInicial.format('YYYY-MM-DD');
        vm.filters.dataFinal = periodo.dataFinal.format('YYYY-MM-DD');
        vm.period.periodo = periodo.descricao;
      }
      loadTarefas();
    }

    function openPeriodsFilter(event) {
      eventStop(event);
      PeriodSelectService.openPeriodSelection(vm.period, vm.filters).then(function() {
        setPeriodo();
      });
    }

    function resetMap() {
      vm.tasks.forEach((task) => {
        if (task.markers) {
          task.markers.forEach((marker) => {
            marker.remove();
            if (marker.circle) {
              marker.circle.remove();
            }
          });
        }
      });
    }

    function resetVariables() {
      vm.filters.page = 1;
      hasPage = true;
      inProgress = false;
      vm.tasks = [];
      vm.data = [];

      vm.filtroPeriodo = PeriodSelectService.getFilterPeriodo($scope.$root.safras);

      if ($routeParams.tarefasFilters) {
        let filters = {};
        if ($routeParams.tarefasFilters) {
          filters = JSON.parse($routeParams.tarefasFilters);
        }
        vm.filters.dataInicial = filters.dataInicial ? moment(filters.dataInicial) : null;
        vm.filters.dataFinal = filters.dataFinal ? moment(filters.dataFinal) : null;
      }
    }

    function finishTask($event, task) {
      LoadingService.showLoading();
      MessagesService.confirm('Deseja realmente marcar esta tarefa como realizada? Esta ação é irreversível!!!')
        .then(function() {
          return TarefasService.close(task);
        })
        .then(function() {
          TarefasService.get(task.id).then((tarefa) => {
            task.finalizado_em = Date.parse(tarefa.finalizadoEm);
          })
            .catch(function() {
              task.finalizado_em = new Date();
            })
            .finally(function() {
              task.status = TarefasService.getTarefaStatus('finalizado');
              MessagesService.alert('Status da tarefa alterado com sucesso');
              LoadingService.hideLoading();
            });
        })
        .catch(function(error) {
          //eslint-disable-next-line no-undefined
          if (typeof error !== 'undefined') {
            MessagesService.alert('Falha ao fechar tarefa, tente novamente');
          }
          LoadingService.hideLoading();
        });
    }

    function checkGlebaInRoute() {
      const selectedGleba = $routeParams.activeGleba || $routeParams.gleba;
      if (selectedGleba) {
        setFilter('gleba', $scope.$root.currentPropriedade.glebas.find((gleba) => gleba.id === +selectedGleba), null);
        return true;
      }
    }

    //////////////////////////////////////////
    // Controller logic

    LoadingService.showLoading();
    $scope.$root.initialize.then(() => {
      if (!$scope.$root.permissions.tarefa.canRead) {
        MessagesService.alert(ACESSO_NAO_PERMITIDO.msg);
        LoadingService.hideLoading();
        return;
      }

      resetVariables();
      if (!checkGlebaInRoute()) {
        loadTarefas();
        HistoricosService
          .listUsuarios({ tipo: 'tarefas' })
          .then((usuarios) => $scope.encarregados = usuarios.data || [])
          .catch((error) => {
            MessagesService.alert('Não foi possível buscar a lista de encarregados.');
            console.error(error);
          });
      }
    });

    $scope.$on('$routeUpdate', function() {
      const gleba = $routeParams.activeGleba || $routeParams.gleba;
      if (_.get(vm, 'filters.gleba.id') !== gleba) {
        checkGlebaInRoute();
      }
    });

    $scope.$on('$destroy', () => resetMap());
  }
}());
